import React from 'react'
import { useTranslation } from 'react-i18next';
import { Label } from 'reactstrap';
import { useTkalDataContext } from '../../../context/tkalData';
import SelectPrinter from '../../common/SelectPrinter';
import InfoModal from '../ahu-estonia/InfoModal';
import { CheckboxDefaultValue, CheckboxOptions } from '../ahu/common/checkboxConfig';
import CheckboxGroupOzonator from './common/CheckboxGroupOzonator';
import MeasurementFieldOzonator from './common/MeasurementFieldOzonator';

const OzonatorPackageForm = () => {
    const { t } = useTranslation();
    const { ozonatorTest, setOzonatorTest } = useTkalDataContext();

    return (
        <form className="ahutest-container" >
            <Label className="ahutest-from--title">{t("Pakend")}</Label>
            <div className="flexboxAlignedColumn" style={{ padding: "2%" }}>
                <div className="ahutest-form__label-info-button--grid" >
                    <Label className="grid-item-label" >{t("Toitekaabel on olemas")}</Label>
                    <InfoModal title={t("Juhend")} bodyText={"1tk"} />
                    <CheckboxGroupOzonator
                        options={CheckboxOptions}
                        defaultValue={CheckboxDefaultValue}
                        measurementKey="cable-package"
                    />
                </div>
                <MeasurementFieldOzonator propertyName="cable-package" showValue={false} />

                <div className="ahutest-form__label-info-button--grid" >
                    <Label className="grid-item-label" >{t("Juhendid on olemas: FIN/ENG, SWE/ENG, EST/ENG")}</Label>
                    <InfoModal title={t("Juhend")} bodyText={"3 lehte"} />
                    <CheckboxGroupOzonator
                        options={CheckboxOptions}
                        defaultValue={CheckboxDefaultValue}
                        measurementKey="instructions-package"
                    />
                </div>
                <MeasurementFieldOzonator propertyName="instructions-package" showValue={false} />

                <div className="ahutest-form__label-info-button--grid" >
                    <Label className="grid-item-label" >{t("Kilbil on pehmendused küljes")}</Label>
                    <InfoModal title={t("Juhend")} bodyText={"2tk"} />
                    <CheckboxGroupOzonator
                        options={CheckboxOptions}
                        defaultValue={CheckboxDefaultValue}
                        measurementKey="cushions-package"
                    />
                </div>
                <MeasurementFieldOzonator propertyName="cushions-package" showValue={false} />

                <div className="ahutest-form__label-info-button--grid" >
                    <Label className="grid-item-label" >{t("Kastil on tootekleebis küljes")}</Label>
                    <InfoModal title={t("Juhend")} bodyText={"1tk"} />
                    <CheckboxGroupOzonator
                        options={CheckboxOptions}
                        defaultValue={CheckboxDefaultValue}
                        measurementKey="sticker-package"
                    />
                </div>
                <MeasurementFieldOzonator propertyName="sticker-package" showValue={false} />

                <div className="ahutest-form__label-info-button--grid" >
                    <Label className="grid-item-label" >{t("Rõhu mõõtmise voolikud on olemas")}</Label>
                    <InfoModal title={t("Juhend")} bodyText={"2 tk mõlemad 40 cm pikad"} />
                    <CheckboxGroupOzonator
                        options={CheckboxOptions}
                        defaultValue={CheckboxDefaultValue}
                        measurementKey="pressure-package"
                    />
                </div>
                <MeasurementFieldOzonator propertyName="pressure-package" showValue={false} />

                <div className="ahutest-form__label-info-button--grid" >
                    <Label className="grid-item-label" >{t("Kiirpaigaldusjuhend")}</Label>
                    <InfoModal title={t("Juhend")} bodyText={"1 leht"} />
                    <CheckboxGroupOzonator
                        options={CheckboxOptions}
                        defaultValue={CheckboxDefaultValue}
                        measurementKey="quickInstructions-package"
                    />
                </div>

                <MeasurementFieldOzonator propertyName="quickInstructions-package" showValue={false} />
                <SelectPrinter defaultPrinter="OZ_Printer" />

                <Label className="grid-item-label" style={{ marginBottom: "5%", marginTop: "2%", marginLeft: "0" }}>{t("Description")}</Label>
                <textarea className="material-textarea-description" style={{ width: "90%" }} value={ozonatorTest.description ? ozonatorTest.description : ""} name="description" placeholder={t("OverallDescription")} maxLength={200}
                    onChange={(e: any) => setOzonatorTest({ ...ozonatorTest, description: e.target.value })} />
            </div>
        </form>
    )
}

export default OzonatorPackageForm